module.exports = class TourCourse {
  constructor(name, course, region, itinerary, timeOfDay, thumbNail) {
    this.name = name || undefined;
    this.course = course || undefined;
    this.region = region || undefined;
    this.itinerary = itinerary || [];
    this.timeOfDay = timeOfDay || false;
    this.thumbNail = thumbNail || undefined;
  }
}
